var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"3.5","fill":"white","stroke":"#E0E9ED"}}),_c('path',{attrs:{"d":"M4 4L12 12M12 4L4 12","stroke":"#858B92","stroke-width":"1.6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }